import type { RailwayService, RailwaySession } from '@cli-types/next-adapter/railway.js'
import { readRailwayServiceVariables } from '@next-adapter/init/railway/resources/read-railway-service-variables.js'
import { collectRailwayDeployEnvVars } from './collect-railway-deploy-env-vars.js'
import { setRailwayVariable } from './set-railway-variable.js'

export async function syncRailwayServiceEnv(
  session: RailwaySession,
  cwd: string,
  service: RailwayService,
  providerOverrides: Record<string, string>
): Promise<{ synced: string[]; failed: string[] }> {
  const existing = await readRailwayServiceVariables(session, cwd, service.name)
  const variables = collectRailwayDeployEnvVars(
    cwd,
    new Set(Object.keys(existing)),
    providerOverrides
  )
  const synced: string[] = []
  const failed: string[] = []

  for (const variable of variables) {
    if (await setRailwayVariable(session, cwd, service, variable)) synced.push(variable.key)
    else failed.push(variable.key)
  }

  return { synced, failed }
}
